module.exports = __webpack_public_path__ + "img/management-philosophy-3.f2707d2a.png";